import { Dropdown } from "@/atoms-react/dropdown/index.react";
import Flag from "@/atoms-react/flag/Flag.react";
import { Base } from "@/atoms-react/text/Text.react";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { CountryCode } from "@/features/utils/types";
import { Fragment } from "react";

const languages = {
  fr: "Français",
  en: "English"
};

type LanguageSelectorProps = {
  size?: string;
  onChange?: (lang: string) => void;
};

export const LanguageSelector = ({ size, onChange }: LanguageSelectorProps) => {
  const { setLanguage, getLanguage } = usei18n();
  return (
    <Dropdown
      className={"inline-block w-auto"}
      items={Object.entries(languages).map(([key, value]) => ({
        key,
        value,
        icon: <Flag countryCode={key} />,
        render: ({ key, value, inDropdown }) => (
          <Fragment key={key}>
            <Flag countryCode={key === "en" ? "gb" : "fr"} />
            {(size !== "sm" || inDropdown) && (
              <div className={"ml-4 flex w-full items-center justify-between"}>
                <Base>{value}</Base>
              </div>
            )}
          </Fragment>
        )
      }))}
      showChevrons
      // search={{
      //   custom: (searchValue, item) => {
      //     return (item.key + ' ' + item.value).toLowerCase().includes(searchValue.toLowerCase())
      //   }
      // }}
      value={getLanguage() as CountryCode}
      onChange={({ key }) => {
        setLanguage(key);
        onChange?.(key);
      }}
    />
  );
};
